import { postPaymentSettings } from '../services/paymentService';

export const defaultPaymentSettings = {
  presencial: {
    enabled: false,
    maxInstallments: 1,
    methods: {
      dinheiro: false,
      pix: false,
      debito: false,
      credito: false,
    },
  },
  aplicativo: {
    enabled: false,
    maxInstallments: 1,
    methods: {
      pix: false,
      debito: false,
      credito: false,
    },
  },
};

export default defaultPaymentSettings;

// Simple model wrapper to persist payment settings via service layer.


export async function savePaymentSettings(settings) {
  try {
    const res = await postPaymentSettings(settings);
    if (res && typeof res.ok === 'boolean') {
      if (!res.ok) {
        const text = await res.text().catch(() => null);
        console.error('[savePaymentSettings] server error', res.status, text);
        try {
          window.localStorage.setItem('paymentSettingsDraft', JSON.stringify(settings));
        } catch (e) {
          console.warn('[savePaymentSettings] failed to write draft', e);
        }
        return { saved: false, draft: settings };
      }
      return res.json().catch(() => ({ saved: true }));
    }
    return res;
  } catch (err) {
    console.error('[savePaymentSettings] network/error', err);
    try {
      window.localStorage.setItem('paymentSettingsDraft', JSON.stringify(settings));
    } catch (e) {
      console.warn('[savePaymentSettings] failed to write draft', e);
    }
    return { saved: false, draft: settings, error: String(err) };
  }
}
